import { render } from "./SyllableAssemblyExerciseComponent.vue?vue&type=template&id=cb1a923e&scoped=true"
import script from "./SyllableAssemblyExerciseComponent.vue?vue&type=script&lang=js"
export * from "./SyllableAssemblyExerciseComponent.vue?vue&type=script&lang=js"

import "./SyllableAssemblyExerciseComponent.vue?vue&type=style&index=0&id=cb1a923e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1a923e"]])

export default __exports__